// extracted by mini-css-extract-plugin
module.exports = {"BaseForm__Error":"BaseForm_BaseForm__Error__34oaL"};